var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.147 7.547H8.84V5.283a.381.381 0 0 0-.385-.377.381.381 0 0 0-.385.377v2.264H5.763a.381.381 0 0 0-.385.378c0 .208.172.377.385.377H8.07v2.264c0 .208.173.377.385.377.212 0 .385-.169.385-.377V8.302h2.307c.213 0 .385-.17.385-.377a.381.381 0 0 0-.385-.378Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.886 19.348-5.715-5.831a7.825 7.825 0 0 0 2.36-5.592C16.532 3.555 12.91 0 8.456 0 4.001 0 .378 3.555.378 7.925c0 4.37 3.623 7.924 8.077 7.924 1.955 0 3.75-.686 5.148-1.823l5.729 5.845a.388.388 0 0 0 .544.01.373.373 0 0 0 .01-.533ZM1.147 7.925c0-3.954 3.278-7.17 7.308-7.17 4.03 0 7.308 3.216 7.308 7.17 0 3.953-3.278 7.17-7.308 7.17-4.03 0-7.308-3.217-7.308-7.17Z"
  }))));
};
export default SvgZoom;